import { combineReducers } from 'redux';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';
import * as ActionTypes from '../actions/ActionTypes';
const EMPTY_LIST = [];
const NO_TOPIC = 'NO_TOPIC';
const requestState = (state = RequestState.UNINITIALIZED, {
  type
}) => {
  switch (type) {
    case ActionTypes.ACCREDITATIONS_REQUESTED:
      return RequestState.PENDING;
    case ActionTypes.ACCREDITATIONS_RECEIVED:
      return RequestState.SUCCEEDED;
    case ActionTypes.ACCREDITATIONS_FAILED:
      return RequestState.FAILED;
    default:
      return state;
  }
};
const data = (state = EMPTY_LIST, {
  type,
  payload
}) => {
  switch (type) {
    case ActionTypes.ACCREDITATIONS_RECEIVED:
      return payload.results.filter(accreditation => accreditation.topic !== NO_TOPIC);
    default:
      return state;
  }
};
export default combineReducers({
  requestState,
  data
});